module.exports = __webpack_public_path__ + "static/media/logo.84d96831.jpg";